export const appLang = {
  language: 'en',
};
